import { ICommonLink } from '@src/models/common';

export const ACCOUNT: ICommonLink = {
  href: '/account',
  id: 'account',
  name: 'Аккаунт',
};

export const LOGIN: ICommonLink = {
  href: `${ACCOUNT.href}/login`,
  id: `${ACCOUNT.id}/login`,
  name: 'Авторизация',
};

export const LOGOUT: ICommonLink = {
  href: `${ACCOUNT.href}/logout`,
  id: `${ACCOUNT.id}/logout`,
  name: 'Выход из учетной записи',
};

export const RESET_PASSWORD: ICommonLink = {
  href: `${ACCOUNT.href}/reset-password`,
  id: `${ACCOUNT.id}/reset-password`,
  name: 'Восстановление пароля',
};
